import React, { Suspense } from 'react';

import Loader from '../../../Loader/Loader';

import type { IProps } from './TinyEditor';

const TinyEditor = React.lazy(() => import(/* webpackChunkName: "tinymce" */ './TinyEditor'));

const LazyTinyEditor: React.FC<IProps> = (props) => (
  <Suspense fallback={<Loader isLoading />}>
    <TinyEditor {...props} />
  </Suspense>
);

export default LazyTinyEditor;
